module.exports = __webpack_public_path__ + "static/media/fitnessLevel.cb9dce1d.svg";